<template>
    <div id="coll">
        <Breadcrumb></Breadcrumb>
        <div class="form-body">
            <el-form :ref="form" :model="form" label-width="80px" style="padding: 0 5px">
                <el-form-item label="店铺名称">
                    <el-radio-group v-model="form.name" class="hide_input">
                        <el-radio label="all">全部</el-radio>
                        <el-radio v-for="(item,index) in dpList" :label="index">{{item}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div style="border-top: 2px dashed #afafaf;padding-top: 5px;">
                    <el-form-item label="搜索类型">
                        <el-radio-group v-model="form.searchType" size="small" class="hide_input">
                            <el-radio :label="1">标题</el-radio>
                            <el-radio :label="2">SKU</el-radio>
                            <el-radio :label="3">产品ID</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="搜索内容">
                        <el-input size="small" v-model="form.searchStr" style="width: 30%;border: 0px;" placeholder="请输入内容"></el-input>
                        <el-button size="small" type="primary" @click="search" style="margin-left: 10px">搜索</el-button>
                        <el-button  type="text" size="mini" @click="gjss = true">高级搜索</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div style="padding-bottom: 10px;display: inline-block;width: 100%">
            <div style="float: left">
                <!--<el-dropdown trigger="click" @command="batchHandle">-->
                    <!--<el-button type="primary" size="small">批量操作</el-button>-->
                    <!--<el-dropdown-menu slot="dropdown">-->
                        <!--<el-dropdown-item command="1">批量取消定时</el-dropdown-item>-->
                        <!--&lt;!&ndash;<el-dropdown-item command="2">批量删除</el-dropdown-item>&ndash;&gt;-->
                    <!--</el-dropdown-menu>-->
                <!--</el-dropdown>-->
                <!--<el-button size="small" type="primary" style="margin-left: 10px">移动分类</el-button>-->
            </div>
            <div style="float: right">

            </div>
        </div>
        <div>
            <el-table id="outTable" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange"
                      :span-method="arraySpanMethod">
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="img" label="图片" width="95" align="center">
                    <template scope="scope">
                        <div>
                            <div class="imgInDiv">
                                <div class="borderDiv">
                                    <img class="imgCls" :src="scope.row.img"/>
                                    <div class="pz_o">
                                        <div class="pz_po">
                                            <div class="pz_at">
                                                <a>添加来源</a>
                                            </div>
                                            <div class="pz_img_o" style="width: 300px;height: 300px;">
                                                <img class="outImg" :src="scope.row.img">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ly">
                                <a>1688</a>
                            </div>
                        </div>

                    </template>
                </el-table-column>
                <el-table-column prop="title" label="标题/产品ID" width="120">
                </el-table-column>
                <el-table-column prop="sppr"  label="SKU" align="center">
                    <template slot-scope="scope">
                        <div v-html="scope.row.sppr"></div>
                    </template>
                </el-table-column>
                <el-table-column label="价格" align="center"></el-table-column>
                <el-table-column label="促销价" align="center"></el-table-column>
                <el-table-column label="库存" align="center"></el-table-column>
                <el-table-column prop="time" label="时间" align="center"></el-table-column>
                <el-table-column prop="handel" label="操作" align="center">
                    <template slot-scope="scope">
                        <!--<el-button  type="text" size="mini" @click="move">取消定时</el-button><br/>-->
                        <!--<el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button><br/>-->
                        <el-button  type="text" size="mini" @click="dialogVisible=true">添加备注</el-button><br/>
                        <!--<el-button  type="text" size="mini" @clcik="deleteRow"></el-button><br/>-->
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>
            <el-pagination background style="float: right;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
                           :total="400">
            </el-pagination>
        </div>

        <el-dialog :close-on-click-modal="false"  
                title="添加备注"
                :visible.sync="dialogVisible"
                width="40%"
                hight="30%">

            <el-form ref="form" :model="form" label-width="110px" >

                <el-form-item label="内容:" >
                    <el-input type="textarea" :rows="8" show-word-limit maxlength="500"
                              v-model="form.desc" placeholder="请输入内容"
                              style="width: 400px;margin-right: 20px"></el-input>
                </el-form-item>
                <hr></hr>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" style="width: 80px;height: 36px;margin-left: 260px">确定</el-button>
                    <el-button  type="primary" @click="dialogVisible = false" style="width: 80px;height: 36px;">取消</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
           </span>
        </el-dialog>


        <!--高级搜索-->

        <el-dialog :close-on-click-modal="false"  
                title="高级搜索"
                :visible.sync="gjss"
                width="45%"
                hight="50%">

            <el-form ref="form" :model="form" label-width="110px">

                <el-form-item label="价格:">
                    <el-col :span="11">
                        <el-input v-model="form.name"></el-input>
                    </el-col>
                    <el-col class="line" :span="1">-</el-col>
                    <el-col :span="11">
                        <el-input v-model="form.name"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="库存:">
                    <el-col :span="11">
                        <el-input v-model="form.name"></el-input>
                    </el-col>
                    <el-col class="line" :span="1">-</el-col>
                    <el-col :span="11">
                        <el-input v-model="form.name"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="站点:">
                    <el-select clearable  v-model="form.region" placeholder="请选择站点">
                        <el-option label="百度" value="shanghai"></el-option>
                        <el-option label="谷歌" value="beijing"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品分类:">
                    <el-select clearable  v-model="form.region" placeholder="请选择产品类型">
                        <el-option label="百度" value="shanghai"></el-option>
                        <el-option label="谷歌" value="beijing"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="发货时间">
                <el-col :span="11">
                <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;"></el-date-picker>
                </el-col>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="search">提交</el-button>
                    <el-button  type="primary" @click="gjss = false">取消</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
           </span>
        </el-dialog>
    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    export default {
        name: "CollectionBox",
        components:{Breadcrumb},
        data() {
            return {
                currentPage: 1,
                dialogVisible: false,
                gjss:false,
                form: {
                    searchStr: null,
                    searchType: 1,
                    name:'',
                },
                dpList: ["店铺1", "店铺2", "店铺3", "店铺4", "店铺5", "店铺6", "店铺7", ],
                tableData: [{
                    img: 'https://wxalbum-10001658.image.myqcloud.com/wxalbum/283967/20200714150201/dd9a1e6e4d2aeeca581cccf8f74a7fc0.jpg',
                    title: 'flower',
                    sppr: '<img src="../../assets/0.png" />',
                    time: '2020-09-01',
                    id: 1
                }],
                spanArr: [],
                innerTableData:[],
                innerData: [
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'}
                ],
            }
        },
        created() {
            var tabHtml ='<table class="innerTab" style="width: 100%">'
            this.innerData.forEach((item,index)=>{
                if(index < 5){
                    tabHtml += `<tr>
					<td >`+item.sku +`</td>
					<td >`+item.price +`</td>
					<td >`+item.price_1 +`</td>
					<td >`+item.rep +`</td>
				</tr>`;
                }else{
                    tabHtml += `<tr style="display: none" class="hid_row">
					<td >`+item.sku +`</td>
					<td >`+item.price +`</td>
					<td >`+item.price_1 +`</td>
					<td >`+item.rep +`</td>
				</tr>`;
                }

            });
            if(this.innerData.length > 5){
                tabHtml += `</table><el-row class="tab_butt"><div id="row_bt" onclick="explanRow()">展开<i class="el-icon-caret-bottom"></i></div></el-row>`;
            }else{
                tabHtml += `</table>`;
            }

            this.tableData[0].sppr = tabHtml;
            window.explanRow = function () {
                var flag = $(".hid_row").is(":hidden");
                if(flag){
                    $("#row_bt").html(`收起<i class="el-icon-caret-top"></i>`);
                    $(".hid_row").show();
                }else{
                    $("#row_bt").html(`展开<i class="el-icon-caret-bottom"></i>`);
                    $(".hid_row").hide();
                }
            }
        },
        methods: {
            onSubmit() {
                alert("提交成功");
            },
            onSubmit2() {
                alert("提交成功");
            },
            setClassManage:function(){
                this.classManageDialog = true;
            },
            closeCMDialog_f:function(){
                this.classManageDialog = false;
            },
            show: function() {

            },
            search: function() {
                this.form.searchStr = "45649";
                alert("查询");
            },
            batchHandle: function(val) {
                if ("1" == val) {
                    this.batchDelete();
                } else {
                    this.batchMove();
                }
            },
            batchDelete: function() {
                this.$confirm('确定要对选中的商品取消定时发布吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '取消成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            batchMove: function() {
                this.$confirm('确定要将选中的商品移入待发布吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '移入成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleSelectionChange: function(val) {
                var ids = [];
                val.forEach((item) => {
                    if (ids.indexOf(item.id) == -1) {
                        ids.push(item.id);
                    }
                });
                this.$message({
                    message: '选择提示:已选择' + ids.length + '条',
                    center: true,
                    offset: 200
                });

            },
            //合并列
            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
                if (columnIndex === 3) {
                    return [1, 4];
                }else if(columnIndex === 4 || columnIndex === 5 ||columnIndex === 6){
                    //将合并后的第四、五、六列单元格清除掉，不然后面的单元格会后移
                    return [0, 0];
                }
            },
            getSpanArr(data) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
                        if (data[i]["id"] === data[i - 1]["id"]) {
                            this.spanArr[this.pos] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.pos = i;
                        }
                    }
                }
            },
            handleSizeChange: function(val) {
                console.log(`每页: ${val}条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            move: function() {
                this.$confirm('确定要 [取消定时发布吗]?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '取消成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            edit: function(row) {
                //直接跳转
                this.$router.replace('/shopeeEdit')
            },
            addNote: function() {

            },
            deleteRow: function() {

            }

        },

        mounted() {
            this.getSpanArr(this.tableData);
            // jQuery(".tab_butt").click(function () {
            //     alert(123456);
            // });
        }
    }
</script>

<style scoped>
    @import '../../../assets/css/Shopee.css';


</style>
